import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Magic from './components/Magic';
import Appearance from './components/Appearance';
import Features from './components/Features';
import UseCases from './components/UseCases';
import Pricing from './components/Pricing';
import Cases from './components/Cases';
import Partners from './components/Partners';
import Team from './components/Team';
import CTA from './components/CTA';
import BusinessCard from './components/BusinessCard';
import JustPage from './components/JustPage';
import { isJustDomain } from './utils/justDomain';

const MainLanding = () => (
  <>
    <Header />
    <Hero />
    <Magic />
    <Appearance />
    <Features />
    <UseCases />
    <Pricing />
    <Cases />
    <Partners />
    <Team />
    <CTA />
  </>
);

const HomePage = () => (isJustDomain() ? <JustPage /> : <MainLanding />);

function App() {
  const onJustDomain = isJustDomain();

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {!onJustDomain && (
            <>
              <Route path="/just" element={<JustPage />} />
              <Route
                path="/card/gleb"
                element={
                  <BusinessCard
                    name="Глеб Пряхин"
                    role="CEO"
                    photo="/images/team/gleb.png"
                    telegram="t.me/Glebsd"
                    email="gleb@performerai.ru"
                  />
                }
              />
              <Route
                path="/card/diana"
                element={
                  <BusinessCard
                    name="Диана Фахритдинова"
                    role="CFO"
                    photo="/images/team/diana.png"
                    telegram="t.me/diana_paradisse"
                    email="diana@performerai.ru"
                  />
                }
              />
            </>
          )}
          {onJustDomain && <Route path="*" element={<JustPage />} />}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
